import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { addDevice, setAddDevice } from '../../../action/cassa';
import ErrorContainer from '../../utils/ErrorContainer';
import Input from '../../utils/Input';
import Select from 'react-select';
import { fetchFilials } from '../../../action/handbook';
import swal from 'sweetalert';
import request from '../../../action/utils/request';
import { urls } from '../../../constants/app';
import { fetchCashiersDevice } from '../../../action/user';

class AddDevice extends Component {
    state = {
        cashiers: [],
    };

    componentDidMount() {
        if (!this.props.filials || this.props.filials.length === 0) this.props.fetchFilials();
        if (!this.props.addForm.host || !this.props.addForm.port || !this.props.addForm.hostMark || !this.props.addForm.portMark) {
            const data = {...this.props.addForm};
            data.host = this.props.addForm.host ? this.props.addForm.host : 'http://127.0.0.1';
            data.port = this.props.addForm.port ? this.props.addForm.port : 16732;
            data.hostMark = this.props.addForm.hostMark ? this.props.addForm.hostMark : 'http://127.0.0.1';
            data.portMark = this.props.addForm.portMark ? this.props.addForm.portMark : 5995;
            this.props.setAddDevice(data);
        }
    }

    componentWillUnmount() {
        this.props.setAddDevice({});
    }
    
    renderSubHeader() {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                <div className="kt-subheader__main">
                    <h3 className="kt-subheader__title">Добавить оборудование</h3>
                    <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                    <div className="kt-subheader__group" id="kt_subheader_search">
                        <span className="kt-subheader__desc">
                            
                        </span>
                    </div>
                </div>        
                <div className="kt-subheader__toolbar">
                    <button onClick={() => this.props.history.push('/cassa/devices')} className="btn btn-default btn-bold">
                        Назад
                    </button>
                </div>
            </div>
            </div>
        );
    }

    isValid() {
        const { name, port, host, ffd, login, password, point} = this.props.addForm;
        if (name && port && host && ffd && login && password && point) return true;
        
        return false;
    }

    setDevice = (field) => (e) => {
        const data = {...this.props.addForm};

        const getCashiers = async (point) => {
            if (point) {
                const result = await this.props.fetchCashiersDevice(point);
        
                if (!result || result.length <= 0 || result.error) {
                    return swal({
                        title: "Ошибка",
                        text: "Не удалось найти кассиров для оборудования",
                        icon: "warning",
                        button: "Ок",
                    });
                }
                return this.setState({ cashiers: result })
            } else {
                return null
            }
        }

        if (field === 'point') {
            this.setState({ cashiers: [] })
            data.user = null;
            getCashiers(e.value);
        }

        if (field === 'point' || field === 'user') {
            data[field] = e;
        } else if (field === 'ffd') {
            data[field] = e.value;
        } else {
            data[field] = e.target.value;
        }
        this.props.setAddDevice(data);
    }

    onSubmit = async (e) => {
        e.preventDefault();
        const params = {};
        params['point.id'] = this.props.addForm.point.value;
        const result = await request({ method: 'get', url: `${urls.devices}`, params });
        const devices = result;

        if (devices && devices.length > 0) {
            return swal({
                title: "У филиала есть оборудование",
                text: "Измените или удалите существующее оборудование филиала",
                icon: "warning",
                button: "Ок",
            });
        }

        this.props.addDevice(this.props.addForm).then(result => {
            if (result) {
                this.props.history.push('/cassa/devices');
            }
        });
    }

    renderAdress(item) {
        return `${item.city.name}, ${item.street}, ${item.house}`;
    }

    renderLabelKashier(item) {
        if (item.name) return `${item.name}, ${item.role.description || ''}`
        return `${item.username}, ${item.role.description || ''}`
    }

    renderAtol = () => {
        const { addForm } = this.props;
        
        return (
            <div className='online-pay_block'>
                <h5> АТОЛ </h5>
                <div className="row">
                    <div className="col-md-4">
                        <Input
                            label="Название ККТ"
                            required={true}
                            onChange={this.setDevice('name')}
                            value={addForm.name}
                            placeholder="Название ККТ"
                        />
                    </div>
                    <div className="col-md-4">
                        <Input
                            label="Логин"
                            required={true}
                            onChange={this.setDevice('login')}
                            value={addForm.login}
                            placeholder="Логин"
                        />
                    </div>
                    <div className="col-md-4">
                        <Input
                            label="Пароль"
                            required={true}
                            onChange={this.setDevice('password')}
                            value={addForm.password}
                            placeholder="Пароль"
                        />
                    </div>                                
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <Input
                            label="IP Хост"
                            required={true}
                            onChange={this.setDevice('host')}
                            value={addForm.host}
                            placeholder="Хост"
                        />
                    </div>
                    <div className="col-md-4">
                        <Input
                            label="Порт"
                            required={true}
                            onChange={this.setDevice('port')}
                            value={addForm.port}
                            placeholder="Порт"
                            type='number'
                        />
                    </div>
                    <div className="col-md-4">
                        <Input
                            label="deviceID"
                            onChange={this.setDevice('deviceId')}
                            value={addForm.deviceId}
                            placeholder="deviceID"
                            type='number'
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className="col-md-6">
                        <div className='form-group'>
                            <label>ФФД *</label>
                            <Select
                                closeMenuOnSelect={true}
                                value={addForm.ffd ? {value: addForm.ffd, label: addForm.ffd} : null}
                                onChange={this.setDevice('ffd')}
                                placeholder="ФФД"
                                options={
                                    [
                                        {value: 1.2, label: 1.2},
                                        {value: 1.05, label: 1.05}
                                    ]
                                }
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className='form-group'>
                            <label>Кассир</label>
                            <Select
                                isLoading={this.props.loadingFilials}
                                isDisabled={this.props.loadingFilials || !addForm.point}
                                closeMenuOnSelect={true}
                                value={(addForm.user && (addForm.user.id || addForm.user.value)) ? { value: addForm.user.id || addForm.user.value, label: addForm.user.label || this.renderLabelKashier(addForm.user) }  : null}
                                onChange={this.setDevice('user')}
                                placeholder="Кассир"
                                options={this.state.cashiers.sort((a, b) => {
                                        const nameA = this.renderLabelKashier(a)
                                        const nameB = this.renderLabelKashier(b)
                                        if (nameA < nameB) return -1;
                                        if (nameA > nameB) return 1;
                                        return 0;
                                        })
                                        .map(el => ({
                                        value: el.id,
                                        label: this.renderLabelKashier(el)
                                        })
                                    )
                                }
                                noOptionsMessage={() => 'Нет пользователей'}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderMark = () => {
        const { addForm } = this.props;
        
        return (
            <div className='online-pay_block'>
                <h5> Честный знак </h5>
                <div className="row">
                    <div className="col-md-4">
                        <Input
                            label="Логин"
                            required={true}
                            onChange={this.setDevice('loginMark')}
                            value={addForm.loginMark}
                            placeholder="Логин"
                        />
                    </div>
                    <div className="col-md-4">
                        <Input
                            label="Пароль"
                            required={true}
                            onChange={this.setDevice('passwordMark')}
                            value={addForm.passwordMark}
                            placeholder="Пароль"
                        />
                    </div>                                
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <Input
                            label="IP Хост"
                            required={true}
                            onChange={this.setDevice('hostMark')}
                            value={addForm.hostMark}
                            placeholder="Хост"
                        />
                    </div>
                    <div className="col-md-4">
                        <Input
                            label="Порт"
                            required={true}
                            onChange={this.setDevice('portMark')}
                            value={addForm.portMark}
                            placeholder="Порт"
                            type='number'
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-8">
                        <Input
                            label="Токен ЧЗ"
                            required={true}
                            onChange={this.setDevice('tokenMark')}
                            value={addForm.tokenMark}
                            placeholder="Токен ЧЗ"
                        />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <Fragment>
                { this.renderSubHeader() }
                <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                    
                <div className="kt-portlet">
                    <form onSubmit={this.onSubmit} className="kt-form">
                        <div className="kt-portlet__body">
                            <div className='row'>
                                <div className="col-md-6">
                                    <div className='form-group'>
                                        <label>{"Филиал *"}</label>
                                        <Select
                                            isLoading={this.props.loadingFilials}
                                            isDisabled={this.props.loadingFilials}
                                            closeMenuOnSelect={true}
                                            value={this.props.addForm.point}
                                            onChange={this.setDevice('point')}
                                            placeholder="Филиал"
                                            options={this.props.filials.map((el) => ({ value: el.id, city: el.city.id, label: this.renderAdress(el)}))}
                                        />
                                    </div>
                                </div>
                            </div>
                            {this.renderAtol()}
                            {this.renderMark()}
                        </div>                        
                        <ErrorContainer field="addDevice" style={{ margin: '0 20px 20px' }} hasCloseButton={true}/>
                        <div className="kt-portlet__foot">
                            <div className="kt-form__actions">
                                <button
                                    disabled={!this.isValid() || this.props.loading}
                                    type="submit"
                                    className={cn({ 'btn btn-brand  kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': this.props.loading })}>
                                    Добавить
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    addForm: state.cassa.devices.add,
    loading: state.loaders.addDevice,
    filials: state.handbook.filials,
    loadingFilials: state.loaders.filials,
});

const mapDispatchToProps = {
    setAddDevice: (data) => setAddDevice(data),
    addDevice: (data) => addDevice(data),
    fetchFilials: (city) => fetchFilials(city, true),
    fetchCashiersDevice: (point) => fetchCashiersDevice(point),
}

export default connect(mapStateToProps, mapDispatchToProps)(AddDevice);